export enum TreasuryStatementPaymentsType {
	ALL = "ALL",
	FINAL = "FINAL",
	NOT_FINAL = "NOT_FINAL"
}
